export const boundariesModerate = [
  [5000, 5000],
  [4816, 5232],
  [4753, 5343],
  [4709, 5435],
  [4676, 5518],
  [4648, 5594],
  [4626, 5666],
  [4606, 5734],
  [4590, 5801],
  [4575, 5865],
  [4562, 5928],
  [4551, 5989],
  [4541, 6050],
  [4533, 6109],
  [4525, 6168],
  [4518, 6226],
  [4512, 6283],
  [4507, 6340],
  [4502, 6397],
  [4498, 6453],
  [4495, 6509],
  [4492, 6564],
  [4490, 6620],
  [4488, 6675],
  [4486, 6730],
  [4485, 6784],
  [4484, 6839],
  [4484, 6894],
  [4484, 6948],
  [4484, 7003],
  [4484, 7057],
  [4485, 7112],
  [4486, 7166],
  [4488, 7220],
  [4489, 7275],
  [4491, 7329],
  [4493, 7384],
  [4495, 7438],
  [4498, 7493],
  [4501, 7547],
  [4503, 7602],
  [4507, 7657],
  [4510, 7712],
  [4513, 7767],
  [4517, 7822],
  [4521, 7877],
  [4524, 7932],
  [4528, 7988],
  [4533, 8043],
  [4537, 8099],
  [4541, 8155],
  [4546, 8211],
  [4551, 8267],
  [4556, 8323],
  [4561, 8380],
  [4566, 8436],
  [4571, 8493],
  [4577, 8550],
  [4582, 8607],
  [4588, 8664],
  [4593, 8722],
  [4599, 8780],
  [4605, 8837],
  [4611, 8895],
  [4617, 8954],
  [4624, 9012],
  [4630, 9071],
  [4636, 9130],
  [4643, 9189],
  [4650, 9248],
  [4656, 9308],
  [4663, 9367],
  [4670, 9427],
  [4677, 9487],
  [4684, 9548],
  [4691, 9608],
  [4699, 9669],
  [4706, 9730],
  [4713, 9791],
  [4721, 9853],
  [4729, 9915],
  [4736, 9977],
  [4744, 10039],
  [4752, 10102],
  [4760, 10164],
  [4768, 10227],
  [4776, 10291],
  [4784, 10354],
  [4792, 10418],
  [4800, 10482],
  [4809, 10546],
  [4817, 10611],
  [4826, 10676],
  [4834, 10741],
  [4843, 10806],
  [4852, 10872],
  [4861, 10938],
  [4869, 11004],
  [4878, 11071],
  [4887, 11137],
  [4896, 11205],
  [4906, 11272],
  [4915, 11340],
  [4924, 11408],
  [4933, 11476],
  [4943, 11544],
  [4952, 11613],
  [4962, 11682],
  [4971, 11752],
  [4981, 11821],
  [4991, 11891],
  [5001, 11962],
  [5011, 12032],
  [5020, 12103],
  [5030, 12175],
  [5040, 12246],
  [5051, 12318],
  [5061, 12390],
  [5071, 12463],
  [5081, 12536],
  [5092, 12609],
];

export const developmentModerate = [
  5000, 5021, 5043, 5064, 5086, 5107, 5129, 5151, 5173, 5195, 5217, 5239, 5261, 5284,
  5306, 5329, 5352, 5374, 5397, 5420, 5443, 5466, 5490, 5513, 5536, 5560, 5584, 5607,
  5631, 5655, 5679, 5703, 5728, 5752, 5777, 5801, 5826, 5851, 5876, 5901, 5926, 5951,
  5976, 6002, 6027, 6053, 6079, 6104, 6130, 6157, 6183, 6209, 6235, 6262, 6289, 6315,
  6342, 6369, 6396, 6424, 6451, 6478, 6506, 6534, 6561, 6589, 6617, 6646, 6674, 6702,
  6731, 6759, 6788, 6817, 6846, 6875, 6904, 6934, 6963, 6993, 7023, 7053, 7083, 7113,
  7143, 7173, 7204, 7235, 7265, 7296, 7327, 7359, 7390, 7421, 7453, 7485, 7516, 7548,
  7581, 7613, 7645, 7678, 7710, 7743, 7776, 7809, 7842, 7876, 7909, 7943, 7977, 8011,
  8045, 8079, 8113, 8148, 8183, 8218, 8252, 8288, 8323,
];

export const fluctuationModerate = [
  5000, 5003, 5318, 5333, 5114, 5179, 5299, 5479, 5538, 5562, 5482, 5373, 5261, 5135,
  5316, 5492, 5514, 5469, 5781, 5599, 5587, 5649, 5745, 5720, 5536, 5383, 5324, 5344,
  5213, 4974, 5041, 5226, 5429, 5561, 5606, 5617, 5826, 6025, 6038, 5949, 5723, 5429,
  5505, 5709, 5788, 5758, 5903, 5979, 6130, 6004, 5820, 5683, 5825, 5954, 6009, 6073,
  6337, 6446, 6654, 6755, 6451, 6365, 6414, 6499, 6589, 6921, 7102, 7224, 7435, 7480,
  7362, 6981, 6788, 6715, 6884, 6962, 6839, 6534, 6335, 6398, 6587, 6960, 7086, 7076,
  7143, 7460, 7441, 7181, 7103, 7382, 7724, 7880, 7844, 7874, 7611, 7522, 7516, 7688,
  7461, 7290, 7197, 7173, 7264, 7532, 7457, 7421, 7900, 8062, 7909, 7927, 7625, 7503,
  7981, 7963, 7841, 7854, 8049, 7867, 7891, 8158, 8323,
];
